import React from "react";
import { useApp } from "../../contexts/AppContext";

const AIBanner = () => {
  const { setIsChatOpen } = useApp();

  return (
    <div className="lg:w-80 flex flex-col gap-6">
      <div className="bg-indigo-600 rounded-[2.5rem] p-8 text-white relative overflow-hidden group ai-glow">
        <div className="relative z-10">
          <h4 className="text-2xl font-black mb-4 leading-tight">
            ✨ ¿Dudas Legales?
          </h4>
          <p className="text-sm text-indigo-100 mb-8 leading-relaxed">
            Nuestro Tutor IA conoce todas las leyes de bienes raíces de Panamá.
            Pregúntale cualquier cosa.
          </p>
          <button
            onClick={() => setIsChatOpen(true)}
            className="w-full bg-white text-indigo-600 py-4 rounded-2xl font-bold text-sm hover:bg-indigo-50 transition-colors"
          >
            Abrir Tutor IA
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIBanner;
